import { useEffect, useState } from "react";

let deferredPrompt = null;

export default function InstallBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

    if (!isMobile) return;

    // Android install prompt
    const handler = (e) => {
      e.preventDefault();
      deferredPrompt = e;

      // show after delay (better UX)
      setTimeout(() => setShow(true), 3000);
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const installApp = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    await deferredPrompt.userChoice;

    deferredPrompt = null;
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 bg-white border border-black/10 rounded-2xl p-4 shadow-xl z-50">
      <div className="flex items-center justify-between">
        <div>
          <div className="font-bold text-sm">Install Brivo360 App</div>
          <div className="text-xs text-black/60">
          For faster access to your portal
          </div>
        </div>
        <button
          onClick={installApp}
          className="px-4 py-2 bg-[#1FA868] text-white rounded-xl text-sm font-bold"
        >
          Install
        </button>
      </div>
    </div>
  );
}